export type KeywordSearchType = 'Top searches' | 'Trending searches';

export interface BrowseKeywordCategory {
  name: string;
  topSearches: string[];
  trendingSearches: string[];
}

export const BROWSE_KEYWORD_SEARCH_TYPES: KeywordSearchType[] = [
  'Trending searches',
  'Top searches',
];
